/* eslint-disable react/prop-types */
import styled from '@emotion/styled';

const CustomBackdrop = styled('div')`
  position: absolute;
  z-index: 1040;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
  transition: color 2s ease;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Backdrop = ({ children, show, ...prop }) => {
  if (show) {
    return <CustomBackdrop {...prop}>{children}</CustomBackdrop>;
  } else {
    return null;
  }
};

export default Backdrop;
